export let skp = [
  {
    id: 654655,
    title: 'Ostatnia szansa! Zamów Opiekę na 2024 i zyskaj aż 40% RABATU',
    start: '2024-08-06',
    end: '2024-10-11',
    description:
      'Ruszyła niepowtarzalna promocja na Opiekę Serwisową 2024, która zapewni Ci wygodną i bezstresową pracę w programie SKP<sup>®</sup>. <br><br>' +
      'Tylko teraz zamówisz Opiekę z <strong class="color-green">40% RABATEM</strong>.<br><br/>' +
      'Nie zwlekaj dłużej i <strong>dołącz do 94% zadowolonych Klientów, którzy zamówili już Opiekę Serwisową i dokonali aktualizacji na rok 2024</strong>.<br><br/>' +
      'Dzięki niej masz zagwarantowany:<br>' +
      '<ul>' +
      '<li><strong>komfort pracy w SKP<sup>®</sup> zawsze na bieżąco aktualizowanym</strong> do zmian w przepisach</li>' +
      '<li>dostęp do <strong>nielimitowanego wsparcia naszych doświadczonych konsultantów</strong>: telefonicznie lub e-mail</li>' +
      '<li>24h na dobę <strong>pomoc Wirtualnego Asystenta SKP<sup>®</sup></strong>, który błyskawicznie odpowie na Twoje pytania.</li>' +
      '</ul><br/>' +
      'Jak skorzystać z promocji? Zamówienie złożysz w Moje Konto w zakładce: Opieka Serwisowa 2024. Następnie przejdź kolejne kroki i dokończ swoje zamówienie.<br/><br/>' +
      'Taniej nie było! Tej promocji na opiekę nie możesz po prostu przegapić!<br>' +
      'Oferta ważna <strong class="color-green">TYLKO do 11 października 2024 roku</strong>. ',
  },
  {
    id: 658,
    title:
      '3,2,1 …WYSTARTOWAŁ BLACK MONTH! <br/> SKORZYSTAJ Z 50% RABATU I ZAMÓW OPIEKĘ SERWISOWĄ NA 2024 ORAZ ROZBUDUJ SWOJE SKP<sup>®</sup>!',
    start: '2023-08-06',
    end: '2023-10-11',
    description:
      'Z niecierpliwością czekasz na BLACK FRIDAY? Mamy dla Ciebie dobrą wiadomość! W FORMSOFT nie ograniczyliśmy się tylko do jednego dnia. U nas świętowanie potrwa dłużej, bo aż 3 tygodnie!.<br><br>' +
      "Tylko TERAZ <strong class='info-text'>RABAT 50% na Opiekę Serwisową 2024 oraz WSZYSTKIE moduły i dodatki!</strong>.<br><br>" +
      'To niepowtarzalna szansa, aby przez dłuższy cieszyć się niskimi cenami.<br><br>' +
      'Dołącz do grona <strong>97% zadowolonych Klientów, którzy cieszą się korzyściami z posiadania Opieki w SKP<sup>®</sup> FORMSOFT</strong>. W ramach jednej opłaty zapewniamy:<br><br>' +
      '<ul>' +
      '<li>pełny dostęp do udostępnianych automatycznie aktualizacji SKP<sup>®</sup> i gwarancję poprawności rozliczeń zgodnie z nowymi przepisami</li>' +
      '<li>nielimitowaną pomoc doświadczonych konsultantów BOK i Wirtualnego Asystenta</li>' +
      '<li>bezpłatny udział w tematycznych webinarach</li>' +
      '<li>bezpłatny dostęp do usługi online SKP24 Connect</li>' +
      '</ul>' +
      '<strong>Nie czekaj i wykorzystaj największą promocję tego roku już teraz!</strong> Zamówienie złożysz bezpośrednio w Twoim SKP<sup>®</sup><br>' +
      "w zakładce: <a href='https://moje-konto.ksiega-podatkowa.pl/skp/zamowienie'>Moje Konto > Opieka Serwisowa 2024</a><br><br>" +
      'Nie przegap szansy! Oferta ważna do <strong>soboty 30.11.2024 r. (godz. 23:59)</strong>.<br><br>' +
      '<a href="https://docs.format.wroc.pl/skp/Black_Month_2024_Regulamin_SKP_Moje_Konto_Klienci_BEZ_Opieki_Serwisowej_na_2024.pdf" target="_blank">Regulamin promocji ></a><br/>',
  },
  {
    id: 6161,
    title:
      '3,2,1 …WYSTARTOWAŁ BLACK MONTH! SKORZYSTAJ Z 50% RABATU I ROZBUDUJ SWOJE SKP<sup>®</sup>!',
    start: '2023-11-06 12:00:00',
    end: '2023-11-30 23:59:59',
    description:
      'Z niecierpliwością czekasz na BLACK FRIDAY? Mamy dla Ciebie dobrą wiadomość! W FORMSOFT nie ograniczyliśmy się tylko do jednego dnia. U nas świętowanie potrwa dłużej, bo aż 3 tygodnie!.<br><br>' +
      "Tylko TERAZ <strong class='info-text'>RABAT 50% na WSZYSTKIE moduły i dodatki!</strong>.<br><br>" +
      'To niepowtarzalna szansa, aby przez dłuższy cieszyć się niskimi cenami.<br><br>' +
      "Przypominamy, że dzięki modułowej budowie SKP<sup>®</sup>, możesz elastycznie konfigurować program oraz w dowolnym momencie rozbudować go o kolejne funkcje. <a href='https://www.ksiega-podatkowa.pl/dla-firm/moduly' target='_blank'>Poznaj wszystkie moduły ></a>.<br><br>" +
      "Nie czekaj i wykorzystaj największą promocję tego roku już teraz! Zamówienie złożysz bezpośrednio w Twoim SKP<sup>®</sup> w zakładce: <a href='https://moje-konto.ksiega-podatkowa.pl/skp/zamowienie'>Moje Konto > Zamówienie</a>.<br><br>" +
      'Nie przegap szansy! Oferta ważna do soboty 30.11.2024 r. (godz. 23:59).<br><br>' +
      '<a href="https://docs.format.wroc.pl/skp/Black_Month_2024_Regulamin_SKP_Moje_Konto_Klienci_z_Opieka_Serwisowa_2024.pdf" target="_blank">Regulamin promocji ></a><br/>',
  },
  {
    id: 6162,
    title:
      '3,2,1 …WYSTARTOWAŁ BLACK MONTH! SKORZYSTAJ Z 50% RABATU I ROZBUDUJ SWOJE SKP<sup>®</sup>!',
    start: '2023-11-06 12:00:00',
    end: '2023-11-30 23:59:59',
    description:
      'Z niecierpliwością czekasz na BLACK FRIDAY? Mamy dla Ciebie dobrą wiadomość! W FORMSOFT nie ograniczyliśmy się tylko do jednego dnia. U nas świętowanie potrwa dłużej, bo aż 3 tygodnie!.<br><br>' +
      "Tylko TERAZ <strong class='info-text'>RABAT 50% na WSZYSTKIE moduły i dodatki!</strong>.<br><br>" +
      'To niepowtarzalna szansa, aby przez dłuższy cieszyć się niskimi cenami.<br><br>' +
      "Przypominamy, że dzięki modułowej budowie SKP<sup>®</sup>, możesz elastycznie konfigurować program oraz w dowolnym momencie rozbudować go o kolejne funkcje. <a href='https://www.ksiega-podatkowa.pl/dla-biur/moduly' target='_blank'>Poznaj wszystkie moduły ></a>.<br><br>" +
      "Nie czekaj i wykorzystaj największą promocję tego roku już teraz! Zamówienie złożysz bezpośrednio w Twoim SKP<sup>®</sup> w zakładce: <a href='https://moje-konto.ksiega-podatkowa.pl/skp/zamowienie'>Moje Konto > Zamówienie</a>.<br><br>" +
      'Nie przegap szansy! Oferta ważna do soboty 30.11.2024 r. (godz. 23:59).<br><br>' +
      '<a href="https://docs.format.wroc.pl/skp/Black_Month_2024_Regulamin_SKP_Moje_Konto_Klienci_z_Opieka_Serwisowa_2024.pdf" target="_blank">Regulamin promocji ></a><br/>',
  },
];
export let skp_f = [
  {
    id: 'custom',
    title: 'Rabat 50% na Opiekę Serwisową 2021',
    start: '2021-11-09',
    end: '2021-11-30',
    description:
      'Skorzystaj z niepowtarzalnej oferty skierowanej do Użytkowników SKP<sup>®</sup>, którzy nie posiadają jeszcze Opieki Serwisowej na rok 2021. Do 30 listopada 2021 Opiekę zamówisz z <strong>50% RABATEM</strong>.</br> \n' +
      'Dlaczego posiadanie Opieki Serwisowej jest takie ważne?<br/> \n' +
      'Od wielu miesięcy pracujesz w programie, który nie uwzględnia zmian wielu przepisów ' +
      'podatkowo-księgowych, które  zostały wprowadzone w bieżącym roku. Zamawiając Opiekę ' +
      'Serwisową zyskujesz gwarancję, iż pracujesz na programie, który jest aktualizowany ' +
      'regularnie, tyle razy w roku, ile to jest konieczne. <br>' +
      'Ponadto, otrzymujesz nieograniczoną możliwość kontaktu z naszymi konsultantami BOK, którzy w razie potrzeby pomogą rozwiązać Twój problem.',
  },
  {
    id: 'cloud',
    title: 'SKP24 Connect Firma ZA DARMO DO KOŃCA ROKU!',
    start: '2021-09-06',
    end: '2021-09-30',
    description:
      'Czy wiesz, że 24h/dobę i z każdego miejsca na świecie możesz mieć bieżący wgląd w dane swojej firmy? Korzystaj z SKP24 Connect Firma, tak jak robi to 73% naszych Klientów.<br><br>' +
      '<strong>SKP24 Connect Firma:</strong><br>' +
      '<ul><li>Wystawiasz faktury on-line i bezpośrednio księgujesz je do SKP<sup>®</sup></li>' +
      '<li>Wysyłasz z SKP<sup>®</sup> wystawione przez siebie dokumenty i przeglądasz je z dowolnego urządzenia</li>' +
      '<li>Zyskasz stały dostęp do bieżących danych (np. deklaracji VAT, składek, podatków do zapłacenia)</li></ul><br>' +
      '<strong>Czym jest usługa SKP<sup>®</sup> w Chmurze?</strong><br>' +
      'Polega na wymianie dokumentów między SKP® zainstalowanym na komputerze stacjonarnym a aplikacją w chmurze. Bez limitu kontrahentów i dokumentów. ' +
      'Chcesz poznać wszystkie korzyści oraz poznać działanie usługi na konkretnych przykładach? Przeczytaj bezpłatny Poradnik: <a target="_blank" class="color-text" href="http://docs.format.wroc.pl/skp/Poradnik_SKP_Firma_w_Chmurze.pdf?ref=mk_promocje_06_09_2021">SKP24 Connect Firma</a><br><br>' +
      '<strong>Jak skorzystać z promocji?</strong><br>' +
      'Przejdź do zakładki <a href="/skp/zamowienie" class="color-text">ZAMÓWIENIE</a>. Następnie w 4 kroku formularza wyślij swoje zamówienie na bezpłatną usługę. Nie zwlekaj z aktywacją! Oferta ograniczona czasowo <span class="color-text">do 30 września 2021 r</span>.<br>',
  },
  {
    id: 656,
    title:
      'Zamów Opiekę na 2024 i zyskaj podwójnie!<br/>' +
      'ZA DARMO: opieka na 2025 rok + usługa online SKP24 Connect ',
    start: '2024-08-06',
    end: '2024-10-11',
    description:
      'Ruszyła niepowtarzalna <strong>KUMULACJA PROMOCJI</strong>, która zapewni Ci wygodną i bezstresową pracę w programie SKP<sup>®</sup> <strong class="color-green">przez kolejne 16 miesięcy!</strong><br><br>' +
      'Dlaczego promocja budzi tyle emocji?<br>' +
      '<ul>' +
      '<li>Kupując Opiekę Serwisową na 2024 <strong class="color-green">otrzymasz ZA DARMO opiekę na cały 2025 rok!</strong></li>' +
      '<li>Ale to nie wszystko! Dodajemy Ci <strong class="color-green">BEZPŁATNY dostęp do usługi online SKP24 Connect Firma do końca roku 2024!</strong> Dzięki niej <strong>wystawisz faktury</strong> z' +
      ' każdego urządzenia z dostępem do Internetu. A do tego zyskasz <strong>stały dostęp online do dokumentów</strong> Twojej firmy!<br/><a target="_blank" href="https://docs.format.wroc.pl/skp/Prezentacja_SKP24_Connect_Firma.pdf?ref=MK-promocje">Zobacz prezentację, dlaczego warto ></a></li>' +
      '</ul><br/>' +
      'Taniej nie było! Tej promocji na opiekę nie możesz przegapić!<br/>' +
      'Oferta ważna <strong class="color-green">TYLKO do 11 października 2024</strong>.<br><br>' +
      'Jak skorzystać z promocji?<br>' +
      '<ul>' +
      '<li>Zamówienie złożysz w zakładce: Opieka Serwisowa 2024.</li>' +
      '<li>W drugim kroku zamówisz usługę online SKP24 Connect. Pamiętaj, aby zaznaczyć wszystkie miesiące do końca roku 2024.</li>' +
      '<li>Następnie przejdź kolejne kroki i dokończ swoje zamówienie.</li>' +
      '</ul><br/>' +
      '<span style="text-decoration: underline;">Ważne! Jeżeli kiedykolwiek korzystałeś z SKP<sup>®</sup> w Chmurze, do zalogowania się w usłudze SKP24 Connect używaj tych samych danych.</span>',
  },
  {
    id: 3,
    title:
      '3,2,1 WYSTARTOWAŁ BLACK WEEK! SKORZYSTAJ Z 50% RABATU I ROZBUDUJ SWOJE SKP<sup>®</sup>!',
    start: '2023-11-20',
    end: '2023-11-28',
    description:
      'Czy wiesz, że dzięki modułowej budowie <strong>SKP<sup>®</sup></strong>, możesz elastycznie konfigurować program oraz w <br>dowolnym momencie rozbudować go o kolejne funkcje?' +
      '<br><a href=" https://www.ksiega-podatkowa.pl/dla-firm/moduly" class="color-text" target="_blank"><strong>Poznaj wszystkie moduły ></strong></a><br><br>' +
      '<strong>Tylko TERAZ RABAT 50% na WSZYSTKIE moduły i dodatki!</strong> <br><br>' +
      'Zamówienie złożysz bezpośrednio w Twoim <strong>SKP<sup>®</sup></strong> w zakładce: <a href="/skp/zamowienie" class="color-text"><strong>Moje Konto > Zamówienie.</strong></a><br>' +
      'Nie zwlekaj! Oferta ważna do <strong>28 listopada 2023 r. (godz. 23:59).</strong>',
  },
  {
    id: 202,
    title: 'POLEĆ ZNAJOMEMU',
    start: '2023-12-04',
    end: '2024-12-03',
    // active: true,
    description:
      'Poleć znajomemu program SKP<sup>®</sup>, a oboje zyskacie atrakcyjne BONUSY.<br> ' +
      'Polecający otrzyma prowizję za każde polecenie programu SKP<sup>®</sup>:<br>' +
      '(50 zł netto za polecenie SKP<sup>®</sup> Firma, 100 zł netto za polecenie SKP<sup>®</sup> Biuro),<br>' +
      'a Znajomy 20% RABATU na SKP<sup>®</sup> START, dowolne moduły i dodatki.<br> ' +
      '<a href="/skp/polec-znajomemu" class="color-text" target="_blank">Zobacz, jak zyskać rabaty ></a> ',
    // '<br>Regulamin promocji dostępny ' +
    // '<a href="https://docs.format.wroc.pl/skp/Regulamin_Promocji_Polec_Znajomemu_SKP.pdf" target="_blank" class="color-text"> TUTAJ</a>.',
  },
  {
    id: 209,
    title:
      'Wystawiaj faktury online w SKP24 Connect - teraz do końca roku za 0 zł!',
    active: true,
    description:
      'Skorzystaj z promocji i zupełnie ZA DARMO KORZYSTAJ z usługi online <strong>SKP24 Connect Firma aż do końca roku 2024.</strong><br/>' +
      'Dzięki niej <strong>wystawisz faktury</strong> z każdego urządzenia z dostępem do Internetu. A do tego zyskasz <strong>stały dostęp online do dokumentów</strong> Twojej firmy!<br/>' +
      'Dowiedz się, jak aplikacja SKP24 Connect Firma ułatwi na co dzień Twoją pracę: <a target="_blank" href="https://docs.format.wroc.pl/skp/Prezentacja_SKP24_Connect_Firma.pdf?ref=MK-promocje" target="_blank">Zobacz prezentację ></a><br/><br/>' +
      'Już teraz przejdź do zakładki Zamówienie, następnie w drugim kroku zaznacz usługę SKP24 Connect na wszystkie miesiące do końca roku 2024 i dokończ swoje zamówienie. <br/>' +
      '<strong class="color-green">Oferta ważna do końca 2024 roku.</strong> <br/><br/>' +
      '<span style="font-style: italic;">Ważne! Jeżeli kiedykolwiek korzystałeś z SKP® w Chmurze, do zalogowania się w usłudze SKP24 Connect używaj tych samych danych.</span>',
  },
];

export let skp_b = [
  {
    id: 'custom',
    title: 'Rabat 50% na Opiekę Serwisową 2021',
    start: '2021-11-09',
    end: '2021-11-30',
    description:
      'Skorzystaj z niepowtarzalnej oferty skierowanej do Użytkowników SKP<sup>®</sup>, którzy nie posiadają jeszcze Opieki Serwisowej na rok 2021. Do 30 listopada 2021 Opiekę zamówisz z <strong>50% RABATEM</strong>.</br> \n' +
      'Dlaczego posiadanie Opieki Serwisowej jest takie ważne?<br/> \n' +
      'Od wielu miesięcy pracujesz w programie, który nie uwzględnia zmian wielu przepisów ' +
      'podatkowo-księgowych, które  zostały wprowadzone w bieżącym roku. Zamawiając Opiekę ' +
      'Serwisową zyskujesz gwarancję, iż pracujesz na programie, który jest aktualizowany ' +
      'regularnie, tyle razy w roku, ile to jest konieczne. <br>' +
      'Ponadto, otrzymujesz nieograniczoną możliwość kontaktu z naszymi konsultantami BOK, którzy w razie potrzeby pomogą rozwiązać Twój problem.',
  },
  {
    id: 657,
    title:
      'Zamów Opiekę na 2024 i zyskaj podwójnie!<br/>' +
      'ZA DARMO: opieka na 2025 rok + usługa online SKP24 Connect ',
    start: '2024-08-06',
    end: '2024-10-11',
    description:
      'Ruszyła niepowtarzalna <strong>KUMULACJA PROMOCJI</strong>, która zapewni Ci wygodną i bezstresową pracę w programie SKP<sup>®</sup> <strong class="color-green">przez kolejne 16 miesięcy!</strong><br><br>' +
      'Dlaczego promocja budzi tyle emocji?<br>' +
      '<ul>' +
      '<li>Kupując Opiekę Serwisową na 2024 <strong class="color-green">otrzymasz ZA DARMO opiekę na cały 2025 rok!</strong></li>' +
      '<li>Ale to nie wszystko! Dodajemy Ci <strong class="color-green">BEZPŁATNY dostęp do usługi online SKP24 Connect Biuro do końca roku 2024!</strong> Dzięki niej <strong>wystawisz faktury</strong> z' +
      ' każdego urządzenia z dostępem do Internetu. A do tego zyskasz <strong>stały dostęp online do dokumentów</strong> Twojej firmy!<br/><a target="_blank" href="https://docs.format.wroc.pl/skp/Prezentacja_SKP24_Connect_Biuro.pdf?ref=MK-promocje">Zobacz prezentację, dlaczego warto ></a></li>' +
      '</ul><br/>' +
      'Taniej nie było! Tej promocji na opiekę nie możesz przegapić!<br/>' +
      'Oferta ważna <strong class="color-green">TYLKO do 11 października 2024</strong>.<br><br>' +
      'Jak skorzystać z promocji?<br>' +
      '<ul>' +
      '<li>Zamówienie złożysz w zakładce: Opieka Serwisowa 2024.</li>' +
      '<li>W drugim kroku zamówisz usługę online SKP24 Connect. Promocją objęty jest pakiet EXTRA – do 10 klientów. Pamiętaj, aby zaznaczyć wszystkie miesiące do końca roku 2024.</li>' +
      '<li>Następnie przejdź kolejne kroki i dokończ swoje zamówienie.</li>' +
      '</ul><br/>' +
      '<span style="text-decoration: underline;">Ważne! Jeżeli kiedykolwiek korzystałeś z SKP<sup>®</sup> w Chmurze, do zalogowania się w usłudze SKP24 Connect używaj tych samych danych.</span>',
  },
  {
    id: 'cloud',
    title: 'SKP24 Connect Biuro ZA DARMO DO KOŃCA ROKU!',
    start: '2021-09-06',
    end: '2021-09-30',
    description:
      'Czy wiesz, że w codziennej pracy biura możesz wykorzystać SKP24 Connect Biuro? Zautomatyzuj współpracę ze swoimi klientami, tak jak robi to 74% naszych Klientów.<br><br>' +
      '<strong>SKP24 Connect Biuro:</strong><br>' +
      '<ul><li>Zaproponujesz swoim Klientom stały i szybki kontakt z Twoim biurem</li>' +
      '<li>Przekażesz im aplikację do wystawiania faktur online</li>' +
      '<li>Ściągniesz bezpośrednio do SKP<sup>®</sup> bieżące sprawy pracownicze, zakupy czy zapłaty dokonane przez Twoich Klientów</li></ul><br>' +
      '<strong>Czym jest usługa SKP<sup>®</sup> w Chmurze?</strong><br>' +
      'Polega na wymianie dokumentów między SKP® zainstalowanym na komputerze stacjonarnym a aplikacją w chmurze. Bez limitu kontrahentów i dokumentów. ' +
      'Chcesz poznać wszystkie korzyści oraz poznać działanie usługi na konkretnych przykładach? Przeczytaj bezpłatny Poradnik: <a target="_blank" class="color-text" href="http://docs.format.wroc.pl/cloud/poradnik-skp-biuro-chmura.pdf?ref=mk_promocje_06_09_2021">SKP24 Connect Biuro</a><br><br>' +
      '<strong>Jak skorzystać z promocji?</strong><br>' +
      'Przejdź do zakładki <a href="/skp/zamowienie" class="color-text">ZAMÓWIENIE</a>. Następnie w 4 kroku formularza wyślij swoje zamówienie na bezpłatną usługę. Nie zwlekaj z aktywacją! Oferta ograniczona czasowo <span class="color-text">do 30 września 2021 r</span>.<br>',
  },
  {
    id: 3,
    title:
      '3,2,1 WYSTARTOWAŁ BLACK WEEK! SKORZYSTAJ Z 50% RABATU I ROZBUDUJ SWOJE SKP<sup>®</sup>!',
    start: '2023-11-20',
    end: '2023-11-28',
    description:
      'Czy wiesz, że dzięki modułowej budowie <strong>SKP<sup>®</sup></strong>, możesz elastycznie konfigurować program oraz w <br>dowolnym momencie rozbudować go o kolejne funkcje?' +
      '<br><a href="https://www.ksiega-podatkowa.pl/dla-biur/moduly" class="color-text" target="_blank"><strong>Poznaj wszystkie moduły ></strong></a><br><br>' +
      '<strong>Tylko TERAZ RABAT 50% na WSZYSTKIE moduły i dodatki!</strong> <br><br>' +
      'Zamówienie złożysz bezpośrednio w Twoim <strong>SKP<sup>®</sup></strong> w zakładce: <a href="/skp/zamowienie" class="color-text"><strong>Moje Konto > Zamówienie.</strong></a><br>' +
      'Nie zwlekaj! Oferta ważna do <strong>28 listopada 2023 r. (godz. 23:59).</strong>',
  },
  // {
  //   id: 603,
  //   title: 'Aż 50% RABATU na moduły i dodatki',
  //   active: true,
  //   description:
  //     'Nie przegap letniej promocji – wszystkie moduły i dodatki zamówisz teraz taniej aż o 50%! <br>' +
  //     'Jak skorzystać z rabatów? Wystarczy, że przejdziesz teraz do zakładki <a href="/skp/zamowienie" class="color-text">ZAMÓWIENIE</a> i wybierzesz to, czego potrzebujesz do prowadzenia swojej firmy. <br>' +
  //     'Nie zwlekaj! Oferta ważna do 10 sierpnia 2021 r. (godz. 23:59). <br>' +
  //     '<a href="http://docs.format.wroc.pl/skp/SKP_Regulamin_promocji_50procent_na_Moduly_i_Dodatki_26.07.2021.pdf" target="_blank" class="color-text font-italic">Regulamin promocji ></a>',
  // },
  // {
  //   id: 206,
  //   title: 'ODBIERZ 50% RABATU NA MODUŁY I DODATKI!',
  //   active: false,
  //   description:
  //     'Skorzystaj z wyjątkowej promocji na Black Week. Teraz <strong>RABAT 50% na WSZYSTKIE moduły i dodatki!</strong><br/>' +
  //     'Zamówienie złożysz bezpośrednio w serwisie <strong>Moje Konto > Zamówienie</strong>.<br/>' +
  //     'Nie zwlekaj! Oferta ważna do <strong>28 listopada 2022 r. (godz. 23:59)</strong>.<br/>' +
  //     '<a href="https://docs.format.wroc.pl/skp/Black_Week_2022_Regulamin_SKP_Moje_Konto.pdf" target="_blank" class="color-text"> Regulamin promocji ></a>.',
  // },
  {
    id: 202,
    title: 'POLEĆ ZNAJOMEMU',
    start: '2023-12-04',
    end: '2024-12-03',
    // active: true,
    description:
      'Poleć znajomemu program SKP<sup>®</sup>, a oboje zyskacie atrakcyjne BONUSY.<br> ' +
      'Polecający otrzyma prowizję za każde polecenie programu SKP<sup>®</sup>:<br>' +
      '(50 zł netto za polecenie SKP<sup>®</sup> Firma, 100 zł netto za polecenie SKP<sup>®</sup> Biuro),<br>' +
      'a Znajomy 20% RABATU na SKP<sup>®</sup> START, dowolne moduły i dodatki.<br> ' +
      '<a href="/skp/polec-znajomemu" class="color-text" target="_blank">Zobacz, jak zyskać rabaty ></a> ',
  },
  // {
  //   id: 203,
  //   title: 'POLEĆ ZNAJOMEMU',
  //   active: false,
  //   description:
  //     'Poleć znajomemu program SKP<sup>®</sup>, a oboje zyskacie atrakcyjne BONUSY.<br> ' +
  //     'Polecający otrzyma prowizję za każde polecenie programu SKP<sup>®</sup>:<br>' +
  //     '(50 zł netto za polecenie SKP<sup>®</sup> Firma, 100 zł netto za polecenie SKP<sup>®</sup> Biuro),<br>' +
  //     'a Znajomy 20% RABATU na SKP<sup>®</sup> START, dowolne moduły i dodatki.<br> ' +
  //     '<a href="/skp/polec-znajomemu" class="color-text" target="_blank">Zobacz, jak zyskać rabaty ></a> ' +
  //     '<br>Regulamin promocji dostępny ' +
  //     '<a href="https://docs.format.wroc.pl/skp/Regulamin_Promocji_Polec_Znajomemu_SKP.pdf" target="_blank" class="color-text"> TUTAJ</a>.',
  // },
  // {
  //   id: 602,
  //   title:
  //     'PODWÓJNY RABAT na zakup dodatków: Wymiana Danych i Wersje Ograniczone!',
  //   active: true,
  //   description:
  //     'Już dziś skorzystaj z podwójnej promocji na rozwiązania, dzięki którym zapomnisz ' +
  //     'o wielu czasochłonnych czynnościach. Zamów praktyczne dodatki z <span class="font-weight-bold">50% RABATEM:</span> ' +
  //     '<ul><li><span class="color-text font-weight-bold">WYMIANA DANYCH</span> teraz <span class="font-weight-bold">79,50 zł netto</span> (zamiast 159,00 netto)</li>' +
  //     '<li><span class="color-text font-weight-bold">WERSJE OGRANICZONE</span> teraz <span class="font-weight-bold">82,00 zł netto</span> (zamiast 164,00 netto)</li></ul>' +
  //     'Aby skorzystać z promocji, należy zamówić przynajmniej jedną Wersję Ograniczoną. ' +
  //     'Dodatki zamówisz w zakładce <a href="/skp/zamowienie" class="color-text">Zamówienie</a>.<br><br> ' +
  //     'Promocja trwa do <span class="font-weight-bold">15.07.2021 r.</span> ' +
  //     '<a href="http://docs.format.wroc.pl/skp/SKP_Regulamin_promocji_BR_Wymiana_danych_wersje_ograniczone_01.07.2021.pdf" target="_blank" class="color-text">Regulamin promocji ></a><br>',
  // },
  {
    id: 'custom',
    title: 'Skorzystaj z promocji 2x50%',
    start: '2023-04-12',
    end: '2023-04-28',
    os: true,
    description:
      'Drogi Użytkowniku, już dziś skorzystaj z podwójnej promocji na rozwiązania, dzięki którym zapomnisz o wielu czasochłonnych czynnościach. Zamów praktyczne dodatki aż 50% taniej:<br/><br/>' +
      '- WYMIANA DANYCH teraz <strong>97 zł </strong> (zamiast 194,00 netto)<br/>' +
      '- WERSJE OGRANICZONE teraz <strong>84,50 zł</strong> netto (zamiast 169,00 zł netto).<br/>' +
      'Jakie korzyści uzyskasz dzięki połączeniu tych 2 dodatków?<br/><br/>' +
      '<ul>' +
      '<li>oszczędzisz czas i zautomatyzujesz pracę swoją oraz Klientów</li>' +
      '<li>zapewnisz łatwą i natychmiastową wymianę dokumentów pomiędzy biurem a Klientami.</li>' +
      '</ul>' +
      '<a href="https://www.ksiega-podatkowa.pl/wymiana-danych-wersje-ograniczone?ref=kom_04_2023_wym_danych_z_os" target="_blank">Dowiedz się, Jak możesz ulepszyć pracę ></a><br/><br/>' +
      'Uwaga: dotatek: Wymiana Danych połącz z co najmniej jedną Wersję Ograniczoną.<br/>' +
      'Promocja trwa do <span class="font-weight-bold">28.04.2023 r.</span><br/>' +
      '<a href="https://docs.format.wroc.pl/skp/SKP_Regulamin_promocji_BR_Wymiana_danych_wersje_ograniczone_12.04.2023.pdf" target="_blank" class="color-text">Regulamin promocji ></a><br>',
  },
  {
    id: 210,
    title:
      'Miej stały kontakt ze swoimi Klientami w SKP24 Connect - teraz do końca roku za 0 zł!',
    active: true,
    description:
      'Skorzystaj z promocji i zupełnie ZA DARMO KORZYSTAJ z usługi online <strong>SKP24 Connect Biuro aż do końca roku 2024.</strong><br/>' +
      'Już dziś bądź w kontakcie ze swoimi Klientami na okrągło, z dowolnego miejsca na świecie! <strong>Wymieniajcie dokumenty online bez ograniczeń</strong> bezpiecznie i wygodnie.<br/>' +
      'Zobacz, jak aplikacja SKP24 Connect Biuro zautomatyzuje pracę Twojego Biura: <a target="_blank" href="https://docs.format.wroc.pl/skp/Prezentacja_SKP24_Connect_Biuro.pdf?ref=MK-promocje" target="_blank">Zobacz prezentację ></a><br/><br/>' +
      'Już teraz przejdź do zakładki Zamówienie, następnie w drugim kroku zaznacz usługę SKP24 Connect Biuro na wszystkie miesiące do końca roku 2024 i dokończ swoje zamówienie.<br/>' +
      '<strong class="color-green">Oferta ważna do końca 2024 roku.</strong> <br/><br/>' +
      '*Promocją objęty jest pakiet EXTRA – do 10 klientów.<br/>' +
      '<span style="font-style: italic;">Ważne! Jeżeli kiedykolwiek korzystałeś z SKP® w Chmurze, do zalogowania się w usłudze SKP24 Connect używaj tych samych danych.</span>',
  },
];

export let skp_t = [
  {
    id: 6,
    title: 'ZYSKAJ BON 150 ZŁ/300 ZŁ NA WYBRANY PROGRAM I MODUŁY',
    start: '2023-10-09 08:00:00',
    end: '2023-10-31 23:59:59',
    description:
      'Skorzystaj z promocji, aby obniżyć cenę swojego zamówienia i rozwijaj z nami swoją firmę!<br/> ' +
      'Odbierz BON RABATOWY: 150 zł netto – na program SKP® Start FIRMA lub 300 zł netto – na program SKP® Start BIURO.<br/> ' +
      'Dodatkowo zyskujesz bezpłatną Opiekę Serwisową na rok 2023 oraz na rok 2024!<br/> ' +
      'Aby skorzystać z promocji dodaj przynajmniej jeden moduł. Rabat uzyskasz w podsumowaniu zamówienia.<br/> ' +
      'Zamów wersję elektroniczną, a program otrzymasz już w 5 minut!<br/><br/> ' +
      'Promocja ograniczona czasowo do 31.10.2023 r. (godz. 23:59). ' +
      '<strong><a href="https://docs.format.wroc.pl/skp/Regulamin_Promocji_BON_RABATOWY_09.10.2023.pdf" class="color-text" target="_blank">Regulamin promocji ></a></strong>' +
      '</p> <p class="g-mt-25" style="position: absolute; bottom: 0; right:30px;">' +
      '<strong><a href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=4&ref=MK_test_promocje" class="color-text" target="_blank">Zamów z RABATEM ></a></strong>',
  },
  {
    id: 3,
    title: 'RABATY DLA UŻYTKOWNIKÓW WERSJI TESTOWEJ',
    active: true,
    description:
      '<strong>Załóż firmę w wersji testowej</strong>, a otrzymasz aż <strong class="color-red;">15% RABATU</strong>' +
      ' na SKP® Start, wszystkie moduły i dodatki. Jak skorzystać z promocji? Składając zamówienie na program zaznacz promocję' +
      ' 15% i podaj swój NIP. Pamiętaj, że rabat zostanie przyznany jedynie po wpisaniu NIP użytego w wersji testowej.' +
      ' Nie zwlekaj! Promocja ważna jest <strong>30 dni</strong> od momentu założenia firmy w tejże wersji.' +
      '</p> <p class="g-mt-25" style="position: absolute; bottom: 0; right:30px;">' +
      '<strong><a href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=8" class="color-text" target="_blank">Zamów z RABATEM ></a></strong>',
  },
  {
    title: 'KURS OBŁSUGI SKP<sup>®</sup> – PROMOCJA PRZEDSPRZEDAŻOWA',
    active: true,
    description:
      'Kup program i odbierz Kurs Obsługi SKP<sup>®</sup> w promocyjnej cenie 0 zł (cena regularna wynosi 179,00 zł netto).<br/><br/>' +
      'I co najważniejsze – <strong>promocja na kurs łączy się z innymi promocjami dla Użytkowników wersji testowej!</strong><br/><br/>' +
      'Dlaczego warto? Podczas szkolenia krok po kroku przedstawimy Ci, jak zacząć prace z programem. Na co należy zwrócić uwagę. Jakich błędów unikać. Kurs to gwarancja szybkiej i skutecznej nauki obsługi programu.<br/><br/>' +
      '</p><p class="g-mt-25 text-right" style="position: absolute; bottom: 0; right:30px;">' +
      '<strong><a href="https://www.ksiega-podatkowa.pl/zamowienie?ref=MK_test_promo" class="color-text" target="_blank">Zamów program i skorzystaj z pakietu promocji ></a></strong>\n</p>',
  },
  {
    id: 1,
    title: 'DLA ROZPOCZYNAJĄCYCH DZIAŁALNOŚĆ',
    active: true,
    description:
      'Złóż zamówienie w ciągu <strong class="color-text">100 dni od daty zarejestrowania nowej działalności ' +
      'gospodarczej </strong>i po automatycznej weryfikacji danych w REGON dostaniesz <strong>21% RABATU</strong> na zamówiony program już na starcie swojej firmy. ' +
      'Składając zamówienie, zaznacz pole: „Dla rozpoczynających działalność”.' +
      '</p><p class="g-mt-25 text-right" style="position: absolute; bottom: 0; right:30px;">' +
      '<strong><a href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=1" class="color-text" target="_blank">Zamów z RABATEM ></a></strong>\n</p>',
  },
  {
    icon: '',
    title: 'DLA ZMIENIAJĄCYCH PROGRAM',
    active: true,
    description:
      'Zastąp swój obecny program elastycznym i sprawdzonym SKP<sup>®</sup>. ' +
      'Złóż zamówienie, prześlij skan lub ksero <strong class="color-text">dowodu zakupu dotychczas używanego programu</strong> o podobnym ' +
      'zakresie działania i wystawionego na tę samą firmę (NIP), która zamierza zakupić SKP<sup>®</sup>, a uzyskasz <strong>25% RABATU</strong>. ' +
      'W formularzu zamówienia zaznacz pole: „Dla zmieniających program”.' +
      '</p> <p class="g-mt-25" style="position: absolute; bottom: 0; right:30px;">' +
      '<strong><a href="https://www.ksiega-podatkowa.pl/zamowienie?ordProm=2" class="color-text" target="_blank">Zamów z RABATEM ></a></strong>',
  },
  // {
  //   id: 301,
  //   title:
  //     'WYJĄTKOWY <strong class="color-text">RABAT 30%</strong> DLA UŻYTKOWNIKÓW ' +
  //     'WERSJI TESTOWEJ!',
  //   active: true,
  //   description:
  //     'Pobierz bezpłatną 60-dniową wersję SKP<sup>®</sup> i zyskaj rabat na zakup ' +
  //     'wybranego programu wraz z modułami. Śpiesz się! Promocja ograniczona czasowo. ' +
  //     'Już teraz <strong><a href="https://www.ksiega-podatkowa.pl/wyprobuj-bezplatnie" class="color-text">wypróbuj SKP<sup>®</sup> za darmo ></a></strong>',
  // },
];

export let sam = [
  {
    id: 'custom',
    title: 'Rabat 50% na Opiekę Serwisową 2021',
    start: '2021-11-09',
    end: '2021-11-30',
    description:
      'Skorzystaj z niepowtarzalnej oferty skierowanej do Użytkowników SAM<sup>®</sup>, którzy nie posiadają jeszcze Opieki Serwisowej na rok 2021. Do 30 listopada 2021 Opiekę zamówisz z <strong>50% RABATEM</strong>.</br> \n' +
      'Dlaczego posiadanie Opieki Serwisowej jest takie ważne?<br/> \n' +
      'Od wielu miesięcy pracujesz w programie, który nie uwzględnia zmian wielu przepisów ' +
      'podatkowo-księgowych, które  zostały wprowadzone w bieżącym roku. Zamawiając Opiekę ' +
      'Serwisową zyskujesz gwarancję, iż pracujesz na programie, który jest aktualizowany ' +
      'regularnie, tyle razy w roku, ile to jest konieczne. <br>' +
      'Ponadto, otrzymujesz nieograniczoną możliwość kontaktu z naszymi konsultantami BOK, którzy w razie potrzeby pomogą rozwiązać Twój problem.',
  },
  {
    id: 'cloud',
    title: 'SAM<sup>®</sup> W CHMURZE ZA DARMO DO KOŃCA ROKU!',
    start: '2021-09-06',
    end: '2021-09-30',
    description:
      'Czy wiesz, że 24h/dobę i z każdego miejsca na świecie możesz mieć bieżący wgląd w dane swojej firmy? Korzystaj z SAM<sup>®</sup> w Chmurze, tak jak robi to 73% naszych Klientów.<br><br>' +
      '<strong>Dzięki SAM<sup>®</sup> w Chmurze:</strong><br>' +
      '<ul><li>Wystawiasz faktury on-line i bezpośrednio księgujesz je do SAM<sup>®</sup></li>' +
      '<li>Wysyłasz z SAM<sup>®</sup> wystawione przez siebie dokumenty i przeglądasz je z dowolnego urządzenia</li>' +
      '<li>Zyskasz stały dostęp do bieżących danych (np. deklaracji VAT, składek, podatków do zapłacenia)</li></ul><br>' +
      '<strong>Czym jest usługa SAM<sup>®</sup> w Chmurze?</strong><br>' +
      'Polega na wymianie dokumentów między SAM® zainstalowanym na komputerze stacjonarnym a aplikacją w chmurze. Bez limitu kontrahentów i dokumentów. ' +
      'Chcesz poznać wszystkie korzyści oraz poznać działanie usługi na konkretnych przykładach? Przeczytaj bezpłatny Poradnik: <a target="_blank" class="color-text" href="http://docs.format.wroc.pl/cloud/Poradnik-SAM-w-Chmurze.pdf?ref=mk_promocje_06_09_2021">SAM<sup></sup> Firma w Chmurze</a><br><br>' +
      '<strong>Jak skorzystać z promocji?</strong><br>' +
      'Przejdź do zakładki <a href="/sam/zamowienie" class="color-text">ZAMÓWIENIE</a>. Następnie w 4 kroku formularza wyślij swoje zamówienie na bezpłatną usługę. Nie zwlekaj z aktywacją! Oferta ograniczona czasowo <span class="color-text">do 30 września 2021 r</span>.<br>',
  },
  // {
  //   id: 603,
  //   title: 'Aż 50% RABATU na moduły i dodatki',
  //   active: true,
  //   description:
  //     'Nie przegap letniej promocji – wszystkie moduły i dodatki zamówisz teraz taniej aż o 50%! <br>' +
  //     'Jak skorzystać z rabatów? Wystarczy, że przejdziesz teraz do zakładki <a href="/sam/zamowienie" class="color-text">ZAMÓWIENIE</a> i wybierzesz to, czego potrzebujesz do prowadzenia swojej firmy. <br>' +
  //     'Nie zwlekaj! Oferta ważna do 10 sierpnia 2021 r. (godz. 23:59). <br>' +
  //     '<a href="http://docs.format.wroc.pl/sam/SAM_Regulamin_promocji_50procent_na_Moduly_i_Dodatki_26.07.2021.pdf" target="_blank" class="color-text font-italic">Regulamin promocji ></a>',
  // },
  // {
  //   id: 202,
  //   title: 'POLEĆ ZNAJOMEMU',
  //   active: false,
  //   description:
  //     'Poleć znajomemu program SAM<sup>®</sup>, a oboje zyskacie atrakcyjne BONUSY. <br/>' +
  //     'Polecający otrzyma prowizję w wysokości 20 zł netto za każde skuteczne polecenie programu SAM<sup>®</sup>' +
  //     ', a Znajomy 20% RABATU na SAM<sup>®</sup> Basic oraz dowolne dodatki.<br> ' +
  //     '<a href="/sam/polec-znajomemu" class="color-text" target="_blank">Zobacz, jak zyskać rabaty ></a> ' +
  //     '<br>Regulamin promocji dostępny ' +
  //     '<a href="http://docs.format.wroc.pl/sam/Regulamin_Promocji_Polec_Znajomemu_SAM_18.05.2021.pdf" target="_blank" class="color-text"> TUTAJ</a>.',
  // },
  {
    id: 204,
    os: false,
    title: 'RABAT 50% na Opiekę Serwisową na 2022 + BONUS',
    active: true,
    description:
      'Pracujesz w programie, który <strong class="color-red-dark">nie jest dostosowany do przepisów obowiązujących w bieżącym roku</strong>, które uległy rewolucyjnym zmianom głównie za sprawą „Polskiego Ładu” i kolejnych, wprowadzonych od 01.07.2022 r. <br/><br/>' +
      'Nie ryzykuj dłużej! Skorzystaj z <strong class="color-green">RABATU 50%</strong> i zamów Opiekę Serwisową 2022 wprost z serwisu Moje Konto > Opieka Serwisowa 2022. <br/><br/>' +
      '<strong>BONUS</strong>: <strong class="color-green">gwarancja BEZPŁATNEGO przejścia na program SKP<sup>®</sup></strong> (usługa dostępna od 27.09.2022 r.). <a href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/zmiana-sam-na-skp-2022" target="_blank">Poznaj korzyści z przejścia na SKP<sup>®</sup> ></a> <br/><br/>' +
      'Promocja ważna do 30.09.2022 r. (do godz. 23:59).',
  },
  {
    id: 205,
    os: true,
    title:
      'BEZPŁATNE przejście z SAM<sup>®</sup> na SKP<sup>®</sup> - wraz z pakietem promocji',
    active: true,
    description:
      '<ul class="greenBig pl-3">' +
      '<li><strong>Za 0 zł otrzymujesz program księgowy SKP<sup>®</sup> Firma</strong> na kolejne lata, z zachowaniem wszystkich modułów i dodatków, które posiadałeś w SAM<sup>®</sup></li>' +
      '<li><strong>Dodatkowy RABAT 35% na Opiekę Serwisową do SKP<sup>®</sup> na rok 2023</strong>, a także <strong>15% RABAT</strong> na opiekę w roku 2024 (promocja ważna do 31.12.2022 r.)</li>' +
      '<li><strong>0 zł za multimedialny Certyfikowany Kurs Obsługi SKP<sup>®</sup></strong></li>' +
      '</ul>',
  },
];

export let sam_t = [
  {
    id: 401,
    title:
      'WYJĄTKOWY <strong class="color-red">RABAT 15%</strong> DLA UŻYTKOWNIKÓW ' +
      'WERSJI TESTOWEJ!',
    active: true,
    description:
      'Pobierz bezpłatną 60-dniową wersję SAM<sup>®</sup> i zyskaj rabat na zakup wybranego ' +
      'programu wraz z praktycznymi dodatkami. Śpiesz się! Promocja ograniczona ' +
      'czasowo. Już teraz <strong><a href="#" class="color-red">wypróbuj SAM<sup>®</sup> za darmo ></a></strong>',
  },
];
